export const GET_REWARDS_ERROR_MESSAGES = {
  USER_NOT_REGISTERED: 'USER_NOT_REGISTERED',
  USER_TOKEN_EXPIRED: 'USER_TOKEN_EXPIRED',
};
